/* lua.js generated code 0.1 */

__DEBUG && $timeStamp('run main first line')

require('env')
require('polyfill')
if (window.mini) {
    require('platform/wechatgame/wx-downloader');
}
require("platform/wechatgame/OpenContextUtil");
require('config')
require('Cocov2Deprecated')
require('clover/utils/functions')
require('clover/utils/SmallResFunction')
require('hecore/utils')
require("clover/utils/EncryptedTool")
require("clover/net/HttpEncryptedLogic")
require("clover/utils/DnSdkTool")
DnSdkTool.getInstance()
window.HTTP_SECRET_KEY_VERSION = "2"


_G.TODO = function(msg) {
    if (__DEBUG) {        
        var __VA_ARG = $slice(arguments, 1)
        cc.log('===[ TODO ]=== ' + string.format(msg, ...__VA_ARG))
    }
}

XcloverPlatform = {
    weixin: 'weixin',
    qq: 'wanba_ts',
    he: 'he',
    huawei: "huawei_quickgame",
    wechatgame : "wechatgame"
}

_G.kDefaultSocialPlatform = 'ios_all'
_G.packageName = he.MetaInfo.getInstance().getPackageName()
_G.bundleVersion = he.MetaInfo.getInstance().getApkVersion()

getText = function(key, param, defaultvalue) {
    // WARN: maybe multi result
    return he.Localization.getInstance().getText(key, param, defaultvalue)
}

_G.kUserLogin = true
_G.kIsNewUser = false
_G.isOHOS = false

// 打点，新用户第一关首次点击开始关卡
_G.hasFirstStartedLevelOne = false
// 打点，新用户第一次第一关加载完毕
_G.firstLevelLoadComplete = false
// 打点，新用户第一关新手引导完成
_G.fisrtAdviseComplete = false
// 打点，新用户第一关首次操作完成(不管是否成功消除)
_G.fisrtSwapItem = false
// 打点，新用户第一关首次通关并开始弹出“下一关”面板
_G.fisrtEndLevelAndStartPopupContainer = false
// 是否使用http2
_G.EnableHttp2 = false 

// _G.packageName = he["MetaInfo"]["getInstance"]()[0]["getPackageName"]()[0]


let ResourceManager = require('./ResourceManager')
ResManager = new ResourceManager();

import SmartLoader from 'clover/utils/SmartLoader'

let ConfigManager = require('./ConfigManager')
CfgManager = new ConfigManager()
let AuthorizeManager = require('./AuthorizeManager')
AuthorizeMgr = AuthorizeManager.getInstance()

function initResManager() {
    ResManager.registerTypeHandler('.plist', path => FrameLoader.loadImageWithPlist(path.replace(/@6x\./, '.')))
    ResManager.registerTypeHandler('.pack', path => {
        // 存在pack未被卸载但是pack中所含资源被卸载的情况
        // 此处在每次pack加载时将pack中的文件加入loader
        // let packData = cc.loader.getRes(path), res = null;
        // for (let path in packData) {
        //     if (!cc.loader.cache[path]) {
        //         cc.loader.cache[path] = packData[path]
        //     }
        // }

        cc.loader.release(path);

        let packed = ResManager.getPackConfig(path)
        if (packed) {
            packed.forEach(item => ResManager.handleFile(item))
        }
    })
    ResManager.registerTypeHandler('.json', path => {
        if (path.indexOf('homeConfig/page/home_page_') > -1) {
            HomeConfigManager.getInstance().loadByPath(path)
        }
    })
    ResManager.registerTypeHandler('.strings', path => {
        let content = ResManager.get(path)
        he.Localization.init(content);
        cc.loader.release(path);
    })
}

CLIENT_ASSETS_PUBLIC_PATH = ASSETS_PUBLIC_PATH
if (__DEBUG) {
    window.loadLaunchSetter = function(complete) {
        const PARAM = LAUNCH_OPTIONS
        const keys = Object.keys(PARAM)
        let count = keys.length;
        if (count == 1) {
            let key = Object.keys(PARAM)[0];
            let oldGetParamByName = window.getParameterByName
            window.getParameterByName = function(name) {
                if (["_resver", "_host", "_host2", "_wshost"].indexOf(name) >= 0)
                    return PARAM[key][name];
                else
                    return oldGetParamByName(name);
            }

            complete();
            return;
        }

        let winSize = cc.Director._getInstance().getWinSize();
        let scene = cc.Scene.create()

        let fontDef = new cc.FontDefinition({
            fontName: 'Microsoft YaHei',
            fontSize: 32,
            fontWeight: 'bold',
            fillStyle: cc.color(0, 0, 0)
        })

        let rowCount = PARAM[keys[count - 1]].row
        const colors = [
            { r: 43, g: 170, b: 255, a: 255 },
            { r: 39, g: 205, b: 232, a: 255 },
            { r: 56, g: 255, b: 227, a: 255 }
        ];
        let w, x, item, index = 0;
        const top = 30, lineHeight = (winSize.height - top) / rowCount;
        let rectMap = {}
        for(let key in PARAM) {
            item = PARAM[key];
            w = (item && item.hasOwnProperty("pos"))? winSize.width / 2: winSize.width;
            x = (item && item["pos"] == "right")? winSize.width / 2: 0;

            let bg = cc.LayerColor.create(colors[index % colors.length], w, lineHeight);
            bg.setPosition(x, winSize.height - lineHeight * item.row - top);
            scene.addChild(bg);

            let textField = cc.LabelTTF.create(key, fontDef)
            textField.setPosition({x: w / 2, y: lineHeight / 2})
            bg.addChild(textField);

            rectMap[key] = {
                x: bg.x, 
                y: bg.y,
                width: bg.width,
                height: bg.height
            }
            index++;
        }

        cc.Director.getInstance().pushScene(scene);
        
        let getKey = (touchPos)=> {
            let r = null;
            for(let key in rectMap) {
                r = rectMap[key];
                if (touchPos.y < r.y + r.height && touchPos.y > r.y && touchPos.x > r.x && touchPos.x < r.x + r.width) {
                    return key;
                }
            }
            return null;
        }

        let listener = cc._EventListenerTouchOneByOne.create()
        listener.setSwallowTouches(true);
        let onChoose = (key)=> {
            console.log(`!!!You choose env [${key}]!!!`);
            cc.eventManager.removeListener(listener)

            let oldGetParamByName = window.getParameterByName
            if (PARAM[key] != null && Object.keys(PARAM[key]).length > 1) {
                window.getParameterByName = function(name) {
                    if (["_resver", "_host", "_host2", "_wshost"].indexOf(name) >= 0)
                        return PARAM[key][name];
                    else
                        return oldGetParamByName(name);
                }
            }

            complete();
        }
        listener.registerScriptHandler((touch, event)=> {
            let touchPos = touch.getLocation()
            let key = getKey(touchPos);
            if (key) {
                if (window.mini && mini.supportModal()) {
                    mini.showModal({
                        content: `你选择了 ${key}`,
                        success: (res)=> {
                            if (res.confirm) {
                                onChoose(key)
                            } 
                        }
                    });
                } else {
                    onChoose(key)
                }
            }
            
        }, cc.Handler.EVENT_TOUCH_BEGAN);
        cc.eventManager.addListener(listener, 1)
        
        if (window.mini && mini.supportPlatformLoading())
            mini.loadingComplete({}) 
    }
}

/**
 * 初始化资源总表
 */
function initRes(evt) {
    cc.loader.resPath = CLIENT_ASSETS_PUBLIC_PATH + 'resource-publish';
    let loadAllSucess = true
    function startGame() {
        if (loadAllSucess){//初始化资源总表出错这里不继续后续操作
            dc4UserLoad(26);
            evt.target.initPreloadScene();
        }
    }
    loadResMap()
    .then(loadPackMap)
    .catch((error, errList)=>{
        // alert('网络异常，初始化游戏失败！请退出重试哦~');
        // 只有smartLoder的错有errList
        let errMsg = "error=" +JSON.stringify(error) + ";errList="+JSON.stringify(errList);
        let networkType = "unknown";
        if (window.mini && mini.supportNetStatus()) {
            mini.getNetworkType({
                success (res) {
                    networkType = res.networkType;
                    window.logCenter && logCenter.error(new Error(`InitResError failed. error=${errMsg} ` + 'NetworkType=' + networkType), 'InitResError');
                },
                fail () {
                    window.logCenter && logCenter.error(new Error(`InitResError failed. error=${errMsg} ` + 'NetworkType=' + networkType), 'InitResError');
                }
            })
        } else {
            window.logCenter && logCenter.error(new Error(`InitResError failed. error=${errMsg} ` + 'NetworkType=' + networkType), 'InitResError');
        }
        console.error(`InitResError failed. error=${errMsg}`,error)                        
        // return Promise.reject({errMsg: msg});
        loadAllSucess = false
        
        require("clover/sns/SnsProxy").getInstance().alert('网络异常，初始化游戏失败！请重试', () => initRes(evt))
    })
    .then(startGame)
}

/**
 * 启动预加载场景
 */
function showPreloadScene() {
    console.log("@@@@rapidly show mode")
    __DEBUG && $timeStamp('startGame - 50')
    let preloadScene = null;
    if (cc.sys.platform === cc.sys.WECHAT_GAME || getCurrentPlatform() == XcloverPlatform.huawei) {
        preloadScene = require("clover/scene/PreloadScene").create();
    } else {
        preloadScene = require("clover/scene/PreloadSceneHtml").create();
    }
    preloadScene.run();
    preloadScene.on("PreloadSceneBgInitEvt", initRes);
    dc4UserLoad(16);
}

function main() {
    dc4UserLoad(11);
    __DEBUG && $timeStamp('run main - 40')

    require('clover/loader/LowDeviceDetectProcessor').start()
    initResManager()
    require('./setup')

    // wanba_ts每30分钟获取一次openkey
    require('clover/sns/SnsProxy')
        .getInstance()
        .setLoginInterval()

    cc.game.onStart = function() {
        __DEBUG && $timeStamp('cc game start')
        _G.__use_low_effect && cc.game.setFrameRate(30);
        cc.director.setContentScaleFactor(_G.__use_res_scale)
        cc.view.enableRetina(true)
        if (cc.sys.platform === cc.sys.DESKTOP_BROWSER) {
            cc.view.resizeWithBrowserSize(true)
        } else {
            // wanba、wechatgame能指定竖屏
            if (window.META.platform !== XcloverPlatform.qq &&
                window.META.platform !== XcloverPlatform.wechatgame &&
                window.META.platform != XcloverPlatform.weixin) {
                // 一般浏览器中，横竖屏不能指定且横竖屏size不一样大
                if (window.META.platform == XcloverPlatform.huawei) {
                    cc.view.enableAutoFullScreen(false)
                }else {
                    cc.view.enableAutoFullScreen(true)
                }
                cc.view.setOrientation(cc.ORIENTATION_PORTRAIT)
                cc.view.resizeWithBrowserSize(true)
            }
        }
        
        // cc.view.adjustViewPort(true)
        // cc.director.setProjection(cc.Director.PROJECTION_2D)
        require('cocos/init')
        
        if (__DEBUG && window.mini)
            window.loadLaunchSetter(showPreloadScene);
        else
            showPreloadScene();
            
        if (window.mini && mini.supportWorldChat()){
            // const offscreenCanvas = wx.createCanvas();
            // let minigameCenter;
            // try {
            //     const MiniGameCenter = requirePlugin('MiniGameCenter', {
            //         enableRequireHostModule: true,
            //         customEnv: {
            //             wx,
            //             window
            //         },
            //     }).default;
            //     minigameCenter = new MiniGameCenter(offscreenCanvas);
            // }
            // catch (e) {
            //     //基础库版本过低
            // }
            // window.offscreenCanvas = offscreenCanvas
            // window.minigameCenter = minigameCenter
            let MiniGameCenter;
            function createMiniGameCenter(options, callback) {
                try {
                    if (typeof requirePlugin !== 'undefined') {
                        if (!MiniGameCenter) {
                            MiniGameCenter = requirePlugin('MiniGameCenter', {
                                enableRequireHostModule: true,
                                customEnv: {
                                    wx,
                                },
                            }).default;
                        }
                        const minigameCenter = new MiniGameCenter(options);
                        if (typeof minigameCenter === 'undefined' || typeof minigameCenter.on === 'undefined') {
                            // 插件初始化失败
                            console.log('minigameCenter create error');
                        } else {
                            // 等待插件初始化完成
                            minigameCenter.on('ready', () => {
                            // 插件ready之后再在其他场景使用，后续通过是否存在GameGlobal.minigameCenter对象来判断组件是否初始化完成
                                window.minigameCenter = minigameCenter;

                            // do something
                            // callback(minigameCenter);
                            });

                            minigameCenter.on('error', (err) => {
                                console.log('插件初始化失败', err);
                            });
                        }
                    }
                } catch (e) {
                    // 基础库版本过低
                    console.log(e);
                }
            }

            // 创建组件，默认隐藏入口
            createMiniGameCenter(
                {
                    autoShow: false,
                },
                () => {
                    // 先判断组件是否初始化完成
                    // if (GameGlobal.minigameCenter) {
                    // 在游戏需要显示的场景手动显示入口
                    // 此处建议在回调里判断根据游戏逻辑代码判断当前场景是否需要显示
                    // GameGlobal.minigameCenter.show();

                    // 设置tabs
                    // GameGlobal.minigameCenter.setTabs(['chat', 'player']);
                    // }
                }
            );
        }
    }
    
    cc.loader.timeout = 15000
    cc.game.run()
}

function requestResConfig(lastRequest) {
    cc.log("requestResConfig lastRequest ",lastRequest)
    if (__DEV) {
        return Promise.resolve(require("resmap-config"))
    }
    return new Promise((resolve,reject)=>{
        let Http = require("./clover/utils/Http")
        let method = "login_getClientConfig"
        let param = getClientConfigParams(method)
        let callback = {}
        callback.handler = function (target, data) {
            if (target == method) {
                console.log("[main] data", data)
                resolve(data)
            }else{
                reject(`[HttpTargetError] cur is ${target}, should be ${method}`)
            }
        };
        callback.onFail = function (err) {
            Http.SwitchHost()
            let errMsg = "[login_getClientConfig] failed. err="+err;
            if (lastRequest){
                window.logCenter && logCenter.error(new Error(errMsg), 'InitResError');
            }else{
                window.logCenter && logCenter.warn(new Error(errMsg), 'InitResError');
            }
            reject(errMsg)
        }
        callback.onTimeOut = function (err) {
            Http.SwitchHost()
            let errMsg = "[login_getClientConfig] failed. err=timeout";
            if (lastRequest){
                window.logCenter && logCenter.error(new Error(errMsg), 'InitResError');
            }else{
                window.logCenter && logCenter.warn(new Error(errMsg), 'InitResError');
            }
            reject(errMsg);
        }

        function parse_response(result) {
            let flag = false
            let data
            let code
            let maintainTime
            try {
                console.log("getClient success, result=", result)
                let tmpResult = JSON.parse(result)
                data = tmpResult["clientConfig"]
                code = tmpResult["code"]
                maintainTime = tmpResult["maintainTime"]
                console.log("@@@@ json ", JSON.stringify(tmpResult))
                if (maintainTime){
                    data['first'] = maintainTime['first']
                    data['second'] = maintainTime['second']
                }
                maintainNotice = tmpResult["maintainNotice"]
                if (maintainNotice){
                    data['firstNotice'] = maintainNotice['first']
                    data['secondNotice'] = maintainNotice['second']
                }
                // console.log("[assets] ASSETS_PUBLIC_PATH="+ASSETS_PUBLIC_PATH)
                // console.log('[assets] data=',data)
                // console.log('[assets] data["assetsUrl"]='+data["assetsUrl"])
                if (data["assetsUrl"] && data["assetsUrl"] != ""){
                    CLIENT_ASSETS_PUBLIC_PATH = data["assetsUrl"]
                    cc.loader.resPath = CLIENT_ASSETS_PUBLIC_PATH + 'resource-publish';
                }
                console.log('[assets] CLIENT_ASSETS_PUBLIC_PATH='+CLIENT_ASSETS_PUBLIC_PATH)
                flag = true
                window.HttpEncryptOpen = data.enableEncrypt || 0
                console.log("[encrypt] window.HttpEncryptOpen ", window.HttpEncryptOpen)
                window.enableWechatDnSDK = data.enableWechatDnSDK || 0;
                console.log("[DnSdkTool] window.enableWechatDnSDK ", window.enableWechatDnSDK)
                let http2Rand = Math.random()
                if (data.enableHttp2Percent && http2Rand < parseFloat(data.enableHttp2Percent)){
                    _G.EnableHttp2 = true
                }
                window.enablePVR = data.enablePvr || 0;
                console.log(`http2Rand=${http2Rand} enableHttp2Percent=${data.enableHttp2Percent}`)
                QAGUI.getInstance().print(`EnableHttp2=${_G.EnableHttp2}`, "http")
                console.log(`enablePVR=${window.enablePVR}`)
                QAGUI.getInstance().print(`enablePVR=${_G.enablePVR}`, "pvr")
            } catch (error) {
                console.error("getClient parse error", result, error)
                data = table()
            }

            //服务器停机维护
            if (code == SERVER_GLOBAL_CODE.SERVER_CLOSED){
                return [true, {code:code}]
            }
            let new_data = {}
            new_data.code = data.retCode
            new_data.data = data
            new_data.desc = data.desc || data.retCode
            return [flag, {code:data.retCode, data:data, desc:data.retCode}]
        }

        Http.send(Http.loginHost + "?" + Http.hostQuery, Http.POST, param, callback, null, method, parse_response)         
    })
}

function loadResMap() {
    let loadList = null;
    let tmpResmapConfig = null;
    let forceBanEtc = null;
    let retryTimes = 0;
    let retryTimesMax = 3;
    //  获取cfgmap连续三次失败后再弹错
    let onError = function(error) {
        retryTimes += 1;
        if (retryTimes < retryTimesMax) {
            return requestResConfig(retryTimes + 1 >= retryTimesMax).catch(onError);
        }
    }
    return requestResConfig()
        .catch(onError)
        .then((resmapConfig)=> {
            tmpResmapConfig = resmapConfig
            loadList = [
                resmapConfig['cfgmap']
            ]
            //TODO:
            window.first = resmapConfig['first']
            window.second = resmapConfig['second']
            window.firstNotice = resmapConfig['firstNotice']
            window.secondNotice = resmapConfig['secondNotice']
            //console.log("@@@@ first && second response:", window.first, window.second)

            let loader = new SmartLoader(loadList);
            return loader.load();
        })
        .then((res)=>{
            let [[cfgMap]] = res;
            cfgMap = cfgMap['config'];
            for(let key in cfgMap)
                ResManager.addMd5Mapping('config/' + key, cfgMap[key]);

            return CfgManager.load("game");
        })
        .then(()=>{
            forceBanEtc = CfgManager.get("game").force_ban_etc;
            // let http_batch_enabled = CfgManager.get("game").http_batch_enabled
            // if (http_batch_enabled && http_batch_enabled == 1){
            //     console.log("[http] BatchEnabled true")
            //     BatchEnabled = true
            // }
            // global.popout_test = CfgManager.get("game").popout_test;
            CfgManager.release("game");

            loadList.forEach(v=> cc.loader.release(v));
            loadList = null;   
            let resmapKey = getResMapName(forceBanEtc);
            console.log('use resmapKey:', resmapKey);
            let resMapFile = tmpResmapConfig[resmapKey];
            let resMapZipFile = tmpResmapConfig[resmapKey + '_zip'];
            if(resMapZipFile) {
                let extname = cc.path.extname(resMapFile) || ''
                ResManager.addZipMapping(resMapFile.substring(0, resMapFile.length - extname.length), extname, resMapZipFile.replace(/\.zip$/, ''));
            }

            loadList = [
                resMapFile
            ]
            let loader = new SmartLoader(loadList);
            return loader.load();

        })
        .then(res=> {
            console.log("$$$$res ", res)
            let [[md5Map]] = res;
            if (__DEBUG && getParameterByName('noresmap'))
                cc.loader.resPath = CLIENT_ASSETS_PUBLIC_PATH + 'resource';

            ResManager.registerMd5Map(md5Map); // 注册资源映射表

            //console.log("$$$$md5 file map ", JSON.stringify(md5Map))

            loadList.forEach(v=> cc.loader.release(v));
            loadList = null;   
            return Promise.resolve();
        });
}

// 获取资源总表key值
// pvr现在测试，只有部分资源使用了pvr，配置在pvr_config.jsonc
function getResMapName(forceBanEtc) {
    let resmapKey = 'resmap';
    if (!_G.__use_low_effect)   
        resmapKey = resmapKey + 'HD'
    if (window.mini && mini.supportUnzip()) {
        let useEtc = checkSupportETC(window.canvas, forceBanEtc)
        // usePvr = false 
        if (useEtc) {
            resmapKey = resmapKey + 'Etc'
            cc.FIX_ARTIFACTS_BY_STRECHING_TEXEL  = 1
        // } else if (usePvr) {
        //     resmapKey = resmapKey + 'Pvr'
        } else
            resmapKey = resmapKey + 'Zip'
    }
    console.log("[etc] resmapKey="+resmapKey)
    return resmapKey;
}
function loadPackMap() {
    return new Promise((resolve,reject)=>{
        let promiseList = null
        if (window.enablePVR == 1){
            promiseList = [ResManager.load('pack_config.json'), ResManager.load('pvr_config.json')]
        }else{
            promiseList = [ResManager.load('pack_config.json')]
        }
        if (window.mini && mini.useStrictImgMode())
            promiseList.push(ResManager.load('meta/safedomain.json'));

        Promise.all(promiseList)
        .then(()=>{
            let packCfg = ResManager.get("pack_config.json");
            ResManager.registerPackMap(packCfg);
            ResManager.release(["pack_config.json"]);
            if (window.enablePVR == 1){
                let pvrListCfg = ResManager.get("pvr_config.json");
                ResManager.registerPVRList(pvrListCfg);
                ResManager.release(["pvr_config.json"]);
            }

            // 游戏中的资源，每关都用，不卸载以提升速度
            ResManager.persist([
                "cocos/commonLib.plist",
                "packed/LevelExtFnt.pack",
                "config/game.json"
            ]);

            if (window.mini && mini.useStrictImgMode()) {
                let safeDomain = ResManager.get('meta/safedomain.json');
                let ary = safeDomain.common;
                let trust = safeDomain[`${mini.getPlatform()}`];
                if (trust)
                    trust.forEach(v=> ary.push(v));
                let warning = safeDomain[`${mini.getPlatform()}_warning`];
                mini.addStrictImgRegexp(ary, warning);

                if (mini.supportOpenContext()) {
                    OpenContextUtil.postMessage ({
                        command: "strict rules",
                        trust: ary,
                        warning: warning
                    });
                    // 显式调用一次exit，不然会误判isOpenContextActive
                    OpenContextUtil.postMessage ({
                        command: "exit"
                    });
                }
                ResManager.release(['meta/safedomain.json']);
            }

            resolve();
        })
        .catch((error)=>{
            console.warn(error)
            let errorCode = -52
            reject(errorCode)
        })
    })
}

// 在尽可能早的时间显示preloader
if (cc.sys.platform !== cc.sys.WECHAT_GAME && getCurrentPlatform() != XcloverPlatform.huawei) {
    document.getElementById('splash').remove()
    document.getElementById('preloader').style.visibility = 'visible'
}
// 下一个事件循环执行main以显示preloader
setTimeout(main, 0);

